import { driveSlikaUrl, driveSrcSet } from "./driveSlike.js";

export const GALERIJA_API_URL = "https://script.google.com/macros/s/AKfycbxytn-34eO_IJnDeLmzvdSj-HP4ZtU8-YJ48OgC27n5OPxmZMqteFRjuaTtKP1HQBXU/exec";

export const GALERIJA_JE_POSTAVLJENA =
  GALERIJA_API_URL.startsWith("https://") && GALERIJA_API_URL.endsWith("/exec");

/*
 * Kartica u mrezi je siroka oko 380px, pa se slika u punoj velicini ondje ne
 * isplati - browser bi povukao 390 kB da prikaze 380px. Mreza zato nudi vise
 * sirina i browser bira najmanju koja mu treba, a puna velicina se dohvaca tek
 * kad se slika otvori preko cijelog ekrana.
 */
const SIRINE_U_MREZI = [400, 600, 800, 1200];
const SIRINE_PUNE = [800, 1200, 1600];
const SIRINA_REZERVNA = 600;
const SIRINA_PUNE = 1200;

const SIZES_MREZA_SLIKA =
  "(max-width: 700px) 92vw, (max-width: 1240px) 46vw, 380px";
const SIZES_MREZA_SKOLA =
  "(max-width: 700px) 92vw, (max-width: 1240px) 46vw, 370px";

const ZAMJENE = {
  č: "c",
  ć: "c",
  đ: "d",
  š: "s",
  ž: "z",
};

export function napraviSlug(ime) {
  return ime
    .toLowerCase()
    .replace(/[čćđšž]/g, (znak) => ZAMJENE[znak])
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function jeNaslovna(imeDatoteke) {
  const bezEkstenzije = imeDatoteke.replace(/\.[^.]+$/, "").toLowerCase();
  return bezEkstenzije.endsWith("_slika") || bezEkstenzije === "naslovna";
}

function jedinstveniSlug(slug, zauzeti) {
  if (!zauzeti.has(slug)) return slug;

  let broj = 2;
  while (zauzeti.has(`${slug}-${broj}`)) broj += 1;
  return `${slug}-${broj}`;
}

export function obradiSkole(podaci) {
  const zauzetiSlugovi = new Set();

  return (podaci?.skole ?? [])
    .map((skola) => {
      const slike = skola?.slike ?? [];
      if (!skola?.ime || slike.length === 0) return null;

      const naslovna = slike.find((s) => jeNaslovna(s.ime)) ?? slike[0];
      const ostale = slike.filter((s) => s !== naslovna);

      const osnovniSlug = napraviSlug(skola.ime);
      if (!osnovniSlug) return null;

      const slug = jedinstveniSlug(osnovniSlug, zauzetiSlugovi);
      zauzetiSlugovi.add(slug);

      return {
        id: slug,
        name: skola.ime,
        thumbnail: {
          src: driveSlikaUrl(naslovna.id, SIRINA_REZERVNA),
          srcSet: driveSrcSet(naslovna.id, SIRINE_U_MREZI),
          sizes: SIZES_MREZA_SKOLA,
        },
        images: ostale.map((s) => ({
          src: driveSlikaUrl(s.id, SIRINA_REZERVNA),
          srcSet: driveSrcSet(s.id, SIRINE_U_MREZI),
          sizes: SIZES_MREZA_SLIKA,
          puna: driveSlikaUrl(s.id, SIRINA_PUNE),
          punaSrcSet: driveSrcSet(s.id, SIRINE_PUNE),
          punaSizes: "90vw",
        })),
      };
    })
    .filter(Boolean);
}

const KLJUC_SPREMNIKA = "galerija-popis";

/*
 * Apps Script odgovara oko dvije sekunde i tek nakon toga krecu slike. Popis se
 * zato pamti do kraja posjeta - povratak na galeriju je onda trenutan. Cuva se
 * samo popis imena i ID-eva; same slike ionako cuva browser.
 */
function procitajIzSpremnika() {
  try {
    const spremljeno = sessionStorage.getItem(KLJUC_SPREMNIKA);
    return spremljeno ? JSON.parse(spremljeno) : null;
  } catch {
    return null;
  }
}

function zapisiUSpremnik(podaci) {
  try {
    sessionStorage.setItem(KLJUC_SPREMNIKA, JSON.stringify(podaci));
  } catch {
    // Privatni prozor ili pun spremnik - galerija radi i bez toga.
  }
}

let uTijeku = null;

export async function dohvatiGaleriju() {
  if (!GALERIJA_JE_POSTAVLJENA) {
    throw new Error(
      "Galerija nije povezana s Driveom - nedostaje Apps Script URL u galerijaData.js"
    );
  }

  const spremljeno = procitajIzSpremnika();
  if (spremljeno) return obradiSkole(spremljeno);

  // Bez ovoga bi dva brza otvaranja galerije pokrenula dva ista zahtjeva.
  if (!uTijeku) {
    uTijeku = fetch(GALERIJA_API_URL)
      .then(async (odgovor) => {
        if (!odgovor.ok) {
          throw new Error(`Galerija nije dostupna (${odgovor.status})`);
        }

        const podaci = await odgovor.json();
        if (podaci?.greska) {
          throw new Error(podaci.greska);
        }

        zapisiUSpremnik(podaci);
        return podaci;
      })
      .finally(() => {
        uTijeku = null;
      });
  }

  return obradiSkole(await uTijeku);
}
